'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Checkbox } from '@/shared/components/primitives/checkbox';
import { toggleFilterInParams } from '@/features/games/internal/helpers/filter-url-helpers';
import { GameCardUIStar } from '@/features/games/shared/components/game-card-ui-star';
import { scrollToTop } from '@/shared/helpers/scroll-to-top';

type RatingFilterItemProps = {
  filterType: string;
  value: string;
  count: number;
  checked: boolean;
};

export const RatingFilterItem = ({ filterType, value, count, checked }: RatingFilterItemProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleToggle = () => {
    const currentParams = Object.fromEntries(searchParams?.entries() ?? []);
    const newParams = toggleFilterInParams(currentParams, filterType, value);
    const newUrl = `${pathname}?${newParams.toString()}`;
    router.replace(newUrl, { scroll: false });
    scrollToTop();
  };

  const ratingValue = Number(value);
  const totalStars = 5;

  return (
    <label className='group hover:text-text-hover flex cursor-pointer items-center gap-2 py-1'>
      <span className='flex flex-1 items-center gap-1'>
        {Array.from({ length: totalStars }, (_, index) => {
          const starIndex = index + 1;
          const fillPct = starIndex <= ratingValue ? 100 : 0;
          return (
            <GameCardUIStar key={starIndex} fillPct={fillPct} size={16} className='inline-block' />
          );
        })}
        <span className='ml-1'>& up</span>
        <span className='text-text-muted'>({count})</span>
      </span>
      <Checkbox checked={checked} onCheckedChange={handleToggle} />
    </label>
  );
};
